/**
 * POS-06 (2026-10-02): today's date in the DEVICE's own time zone (Pakistan
 * shops → Pakistan date). `new Date().toISOString()` gives the UTC date, which
 * dated sales between midnight and 5 am as the previous day.
 * Returns 'YYYY-MM-DD'.
 */
export const localDateStr = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
